module.exports = __webpack_public_path__ + "static/media/13_tn.a267eccb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/13_tn.jpg
// module id = 151
// module chunks = 0